import React, { useMemo, useState, useEffect } from "react";
import axios from "axios";
import { Modal, Button } from "react-bootstrap";
import apiUrl from "../../environment/Api";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import Select from "react-select";
import styled from "styled-components";
import {
  useTable,
  useFilters,
  useGlobalFilter,
  useSortBy,
  usePagination,
} from "react-table";
import { createPortal } from "react-dom";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import ActionsDropdown from "../ActionsDropdown";

const TableContainer = styled.div`
  padding: 20px;
  overflow-x: auto;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #ddd;

  // Apply striped rows styling
  tr:nth-child(even) {
    background-color: #ffffff; /* Light gray for even rows */
  }

  tr:nth-child(odd) {
    background-color: #f2f2f2; /* White for odd rows */
  }
`;

const Th = styled.th`
  padding: 10px;
  background-color: #ffffff;
  text-align: left;
  cursor: pointer;
  position: relative;
`;

const Td = styled.td`
  padding: 10px;
  // border: 1px solid #ddd;
`;

function GlobalFilter({ globalFilter, setGlobalFilter }) {
  return (
    <div style={{ marginBottom: "10px" }}>
      <input
        value={globalFilter || ""}
        onChange={(e) => setGlobalFilter(e.target.value)}
        placeholder="Search all columns..."
        style={{
          padding: "5px",
          border: "1px solid #ddd",
          borderRadius: "4px",
          width: "100%",
        }}
      />
    </div>
  );
}
// Default Column Filter (Icon-based)
const DefaultColumnFilter = ({
  column: { filterValue, setFilter, preFilteredRows, id },
}) => {
  const [isActive, setIsActive] = useState(false);
  const [selectedValue, setSelectedValue] = useState(null);
  const options = useMemo(() => {
    const uniqueValues = Array.from(
      new Set(preFilteredRows.map((row) => row.values[id]))
    ).map((value) => ({ label: value, value }));
    return [{ label: "All", value: "" }, ...uniqueValues];
  }, [id, preFilteredRows]);

  // Handle icon click
  const handleIconClick = () => {
    setIsActive(!isActive);
  };

  const handleMultiSelectChange = (selectedOptions) => {
    const values = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    setFilter(values.length > 0 ? values : undefined);
  };

  return (
    <div style={{ alignItems: "center" }}>
      <div>
        <i
          className="fa-solid fa-ellipsis-vertical"
          onClick={handleIconClick}
          style={{
            cursor: "pointer",
            fontSize: "20px",
            color: "#AC0000",
          }}
        ></i>
      </div>
      <div>
        {isActive &&
          createPortal(
            <div
              style={{
                position: "fixed",
                zIndex: 9999,
                left: "50%",
                top: "50%",
                width: "30%",
                transform: "translate(-50%, -50%)",
              }}
            >
              <div
                style={{
                  position: "relative",
                  background: "white",
                  padding: "20px",
                  borderRadius: "8px",
                  boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                  backgroundColor: "#A70000",
                }}
              >
                <Select
                  options={options}
                  isMulti
                  value={options.filter((option) =>
                    filterValue?.includes(option.value)
                  )}
                  onChange={handleMultiSelectChange}
                  isClearable
                  isSearchable
                  placeholder={`Filter ${id}`}
                  styles={{
                    menu: (provided) => ({
                      ...provided,
                      zIndex: 9999,
                    }),
                  }}
                />
                <button
                  style={{
                    marginTop: "10px",
                    marginLeft: "150px",
                    padding: "5px 10px",
                    background: "#007bff",
                    color: "white",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                  }}
                  onClick={() => setIsActive(false)} // Close the popup
                >
                  Close
                </button>
              </div>
            </div>,
            document.body
          )}
      </div>
    </div>
  );
};

function Course() {
  const [responseData, setResponseData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isUpdateshowModal, setUpdateShowModal] = useState(false);
  const [showModals, setShowModals] = useState(false);
  const [branch, setbranch] = useState([]);
  const [category, setcategory] = useState([]);
  const [role_id, setroleid] = useState("");
  const [previllages, setprevillages] = useState({});
  const [rolename, setrolename] = useState([]);


  const data = useMemo(() => {
    return responseData.map((item) => ({
      _id: item._id,
      course_id: item.course_id,
      course_name: item.course_name,
      category_list: item.category_list,
      description: item.description,
      discount: item.discount,
      special_offer: item.special_offer,
      duration: item.duration,
      fees: item.fees,
      status: item.status,
    }));
  }, [responseData]);


  const columns = useMemo(
    () => [
      {
        Header: "S.No",
        id: "serialNo",
        Cell: ({ row }) => {
          return row.index + 1;
        },
      },
      {
        Header: "Code",
        accessor: "course_id",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
      },
      {
        Header: "Course",
        accessor: "course_name",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
      },
      //{
      //   Header: "Discount Upto",
      //   accessor: "discount",
      //   Filter: DefaultColumnFilter,
      //   filter: "multiSelectFilter",
      // }, 
      {
        Header: "Duration",
        accessor: "duration",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
      }, {
        Header: "Fees",
        accessor: "fees",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
      },
      //  {
      //   Header: "Status",
      //   accessor: "status",
      //   Filter: DefaultColumnFilter,
      //   filter: "multiSelectFilter",
      // },
      {
        Header: "Status",
        accessor: "status",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
        Cell: ({ value }) => {
          // Conditional logic for the status
          if (value === "Active") {
            return (
              <td className="text-center hideres">
                <p className="text-white green-label">{value}</p>
              </td>
            );
          } else {
            return (
              <td className="text-center hideres">
                <p className="text-white red-label">{value}</p>
              </td>
            );
          }
        },
      },


    ],
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    state,
    setGlobalFilter,
    setPageSize,
    page,
    canPreviousPage,
    canNextPage,
    pageCount,
    gotoPage,
  } = useTable(
    {
      columns,
      data,
      initialState: { pageSize: 10 },
      defaultColumn: { Filter: DefaultColumnFilter },
      filterTypes: {
        multiSelectFilter: (rows, columnIds, filterValue) => {
          if (!filterValue || filterValue.length === 0) {
            return rows;
          }
          return rows.filter((row) => {
            const rowValue = row.values[columnIds[0]];
            const rowValueStr = String(rowValue);
            return filterValue.some((filterVal) =>
              rowValueStr.includes(String(filterVal))
            );
          });
        },
      },
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination
  );



  const [addData, setAddData] = useState({
    branch_id: "",
    course_id: "",
    course_name: "",
    category_list: "",
    description: "",
    discount: "",
    special_offer: "",
    duration: "",
    fees: "",
    status: "",
    image: "",
  });

  const [updateData, setUpdateData] = useState({
    branch_id: "",
    course_id: "",
    course_name: "",
    category_list: "",
    description: "",
    discount: "",
    special_offer: "",
    duration: "",
    fees: "",
    status: "",
    image: "",
  });

  useEffect(() => {
    fetchData();
    fetchDataed();
    gettoken();
    fetch();
    const rolename = localStorage.getItem("rolename");
    setrolename(rolename);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
    getprevillages();
  }, []);



  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(apiUrl + "/course", {
        params: { data: localStorage.getItem("branch_id") },
      });

      if (response && response.status === 200) {
        setTimeout(() => {
          setLoading(false);
        }, 500);
      }

      console.log("Response from server:", response.data);
      setResponseData(response.data.reverse());
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const fetchDataed = async () => {
    try {
      const response = await axios.get(apiUrl + "/Branch");
      console.log("Response from server:", response.data);
      setbranch(response.data);
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const fetch = async () => {
    try {
      const response = await axios.get(apiUrl + "/category_list");
      console.log("Response from server:", response.data);
      setcategory(response.data);
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const gettoken = async () => {
    const token = localStorage.getItem("token");
    try {
      const response = await axios.post(apiUrl + "/get_detail", {
        token: token,
      });
      console.log("token detail from server:", response.data);

      setroleid(response.data.detail.rolename);

      localStorage.setItem("role_id", response.data.detail.rolename);

      const id = response.data.detail.rolename;
      if (id) {
        // try {
        //   const response = await axios.get(apiUrl + `/role_2/${id}`);
        //   const modules = response.data.modules;
        //   const filtered_access = modules.filter(
        //     (item) => item.name == "Branch"
        //   );
        //   setprevillages(filtered_access[0].actions);
        // } catch (error) {
        //   console.error("Error fetching data:", error.message);
        // }
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const getprevillages = () => {
    const username = JSON.parse(localStorage.getItem("user_previllages"));
    console.log("tyhe username get by local stroage : ", username.modules);

    const total_previlages = username.modules;

    const new_enquiry = total_previlages.find((item) => item.name == "Course");

    console.log("the new_enquiry is : ", new_enquiry.actions);

    setprevillages(new_enquiry.actions);
  };

  const handleNewButtonClick = () => {
    if (previllages.add || previllages.all) {
      setShowModal(true);
    } else {
      toast.error("You don't have the permission to add");
    }
  };

  const handlesubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const formData = {
        branch_id: addData.branch_id,
        course_name: addData.course_name,
        course_id: addData.course_id,
        category_list: addData.category_list,
        discount: addData.discount,
        special_offer: addData.special_offer,
        description: addData.description,
        duration: addData.duration,
        fees: addData.fees,
        status: addData.status,
        image: addData.image,
      };
      const response = await axios.post(apiUrl + "/course", formData);
      console.log("Updated:", response);
      toast.success("added successfully!");
      setShowModal(false);
      setAddData({
        branch_id: "",
        course_id: "",
        course_name: "",
        category_list: "",
        description: "",
        discount: "",
        special_offer: "",
        duration: "",
        fees: "",
        status: "",
        image: "",
      });
      setTimeout(() => {
        setLoading(false);
      }, 1000);
      fetchData();
    } catch (error) {
      console.error("Error updating data:", error.message);
    }
  };

  const [updateid, setUpdateId] = useState("");

  const handleUpdate = (_id, data) => {
    if (previllages.edit || previllages.all) {
      setUpdateId(_id);
      console.log(" the data to updata", data);
      setUpdateShowModal(true);
      setUpdateData({
        branch_id: data.branch_id,
        course_id: data.course_id,
        discount: data.discount,
        special_offer: data.special_offer,
        course_name: data.course_name,
        category_list: data.category_list,
        description: data.description,
        duration: data.duration,
        fees: data.fees,
        status: data.status,
        image: data.image,
      });
    } else {
      toast.error("You don't have the permission to update");
    }
  };

  const handleupdatesubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const formData = {
        branch_id: updateData.branch_id,
        course_id: updateData.course_id,
        discount: updateData.discount,
        category_list: updateData.category_list,
        special_offer: updateData.special_offer,
        course_name: updateData.course_name,
        description: updateData.description,
        duration: updateData.duration,
        fees: updateData.fees,
        status: updateData.status,
        image: updateData.image,
      };
      console.log("the update submit data", formData);
      const response = await axios.put(
        apiUrl + `/course/${updateid}`,
        formData
      );
      console.log("response for update", response);
      setUpdateShowModal(false);
      toast.success("Update successfully!");
      setTimeout(() => {
        setLoading(false);
      }, 1000);
      fetchData();
    } catch (error) {
      console.error("Error updating data:", error.message);
    }
  };

  const handleDelete = async () => {
    try {
      setLoading(true);
      await axios.delete(apiUrl + `/course/${getdeleteid}`);
      toast.error("Deleted successfully!");
      setShowModals(false);
      setTimeout(() => {
        setLoading(false);
      }, 1000);
      fetchData(); // Refetch data after deletion
    } catch (error) {
      console.error("Error deleting course:", error.message);
    }
  };

  const handleCloseModal = () => {
    setShowModals(false);
  };

  const [getdeleteid, setdeleteid] = useState("");
  const [getdeletename, setdeletename] = useState("");
  const handleOpenModal = (_id, course_name) => {
    if (previllages.all || previllages.delete) {
      console.log(" the id", _id);
      console.log(" the coursename", course_name);
      setdeleteid(_id);
      setdeletename(course_name);
      setShowModals(true);
    } else {
      toast.error("You don't have the permission  to add");
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const day = date.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  // the pagination ---------------------------------------------------------------------
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  // Pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = responseData.slice(indexOfFirstItem, indexOfLastItem);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const filtered = rows.filter((item) =>
    Object.values(item).some(
      (value) =>
        (typeof value === "string" &&
          value.toLowerCase().includes(searchQuery.toLowerCase())) ||
        (typeof value === "number" && value.toString().includes(searchQuery))
    )
  );

  // const createPagination = () => {
  //   let liTag = [];

  //   // Previous Page Button
  //   liTag.push(
  //     <li
  //       className={`page-item ${!canPreviousPage ? "disabled" : ""}`}
  //       key="prev"
  //     >
  //       <button
  //         className="page-link"
  //         onClick={() => canPreviousPage && gotoPage(state.pageIndex - 1)}
  //         disabled={!canPreviousPage}
  //       >
  //         <FaAngleLeft /> Prev
  //       </button>
  //     </li>
  //   );

  //   // Page Numbers
  //   for (let plength = 1; plength <= pageCount; plength++) {
  //     liTag.push(
  //       <li
  //         key={plength}
  //         className={`page-item ${plength === state.pageIndex + 1 ? "active" : ""
  //           }`}
  //       >
  //         <button
  //           className="page-link"
  //           onClick={() => gotoPage(plength - 1)} // 0-indexed
  //         >
  //           {plength}
  //         </button>
  //       </li>
  //     );
  //   }

  //   // Next Page Button
  //   liTag.push(
  //     <li className={`page-item ${!canNextPage ? "disabled" : ""}`} key="next">
  //       <button
  //         className="page-link"
  //         onClick={() => canNextPage && gotoPage(state.pageIndex + 1)}
  //         disabled={!canNextPage}
  //       >
  //         Next <FaAngleRight />
  //       </button>
  //     </li>
  //   );

  //   return liTag;
  // };



  const createPagination = () => {
    let liTag = [];
    let totalPages = pageCount; // Total pages
    let currentPage = state.pageIndex;
    let active;

    // Previous Page Button
    liTag.push(
      <li className={`page-item ${!canPreviousPage ? "disabled" : ""}`} key="prev">
        <button
          className="page-link"
          onClick={() => gotoPage(currentPage - 1)}
          disabled={!canPreviousPage}
        >
          <FaAngleLeft /> Prev
        </button>
      </li>
    );

    // Always show first page
    if (totalPages > 1) {
      liTag.push(
        <li className={`page-item ${currentPage === 0 ? "active" : ""}`} key={0}>
          <button className="page-link" onClick={() => gotoPage(0)}>
            1
          </button>
        </li>
      );
    }

    // Show second page if total pages > 2
    if (totalPages > 2) {
      liTag.push(
        <li className={`page-item ${currentPage === 1 ? "active" : ""}`} key={1}>
          <button className="page-link" onClick={() => gotoPage(1)}>
            2
          </button>
        </li>
      );
    }

    // Add "..." before current page group
    if (currentPage > 3) {
      liTag.push(
        <li className="page-item disabled" key="dot-prev">
          <span className="page-link">...</span>
        </li>
      );
    }

    // Show 3 pages around current page
    for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 3, currentPage + 1); i++) {
      active = currentPage === i ? "active" : "";
      liTag.push(
        <li className={`page-item ${active}`} key={i}>
          <button className="page-link" onClick={() => gotoPage(i)}>
            {i + 1}
          </button>
        </li>
      );
    }

    // Add "..." after current page group
    if (currentPage < totalPages - 4) {
      liTag.push(
        <li className="page-item disabled" key="dot-next">
          <span className="page-link">...</span>
        </li>
      );
    }

    // Always show last two pages if totalPages > 2
    if (totalPages > 2) {
      liTag.push(
        <li className={`page-item ${currentPage === totalPages - 2 ? "active" : ""}`} key={totalPages - 2}>
          <button className="page-link" onClick={() => gotoPage(totalPages - 2)}>
            {totalPages - 1}
          </button>
        </li>
      );
    }

    if (totalPages > 1) {
      liTag.push(
        <li className={`page-item ${currentPage === totalPages - 1 ? "active" : ""}`} key={totalPages - 1}>
          <button className="page-link" onClick={() => gotoPage(totalPages - 1)}>
            {totalPages}
          </button>
        </li>
      );
    }

    // Next Page Button
    liTag.push(
      <li className={`page-item ${!canNextPage ? "disabled" : ""}`} key="next">
        <button
          className="page-link"
          onClick={() => gotoPage(currentPage + 1)}
          disabled={!canNextPage}
        >
          Next <FaAngleRight />
        </button>
      </li>
    );

    return liTag;
  };

  // =============================================

  const navigate = useNavigate();

  // const handleClickImage = (id, course_id) => {
  //   navigate(`/courseimagepreview/${id}/${course_id}`);
  // };
  // ===========recent image comment
  // const handleClickImage = (id, course_id) => {
  //   // Navigates to the desired route with the parameters
  //   navigate(`/courseimagepreview/${id}/${course_id}`);
  // };

  const handleCourseInfo = (id, course_id) => {
    navigate(`/coursepreview/${id}/${course_id}`);
  };
  const [loading, setLoading] = useState(false);


  useEffect(() => {

    const branchName = localStorage.getItem("branch_name");
    setrolename(branchName);
  }, []);



  // the pagination  end ---------------------------------------------------------------------
  return (
    <>
      {loading === true ? (
        <div className="loading-overlay">
          <div className="loading-message">
            <img
              className="loadinggif"
              src={require("../../assets/img/output-onlinegiftools.gif")}
            />{" "}
          </div>
        </div>
      ) : (
        <div className="d-none"></div>
      )}
      <div className="top">
        <div className="" style={{ marginTop: "-80px" }}>
          <div className="row mb-3">
            <div className="col-lg-11">
              <Link to="/dashboard" className="text-secondary dashBoard_text">
                <b>Dashboard / </b>
              </Link>
              <Link to="" className="text-danger dashBoard_text">
                <b>Course</b>
              </Link>
            </div>
          </div>
        </div>
        {/* <div className="row">
          

        </div> */}

        {/* ------------ search and per page ----------------------------*/}
        <div className="mb-1 mt-3">
          <div className="row">
            <div className="col-lg-7 col-md-4 col-sm-1">
              <div className="d-flex">
                <h5 className="mt-1">Course </h5>
                <div className="mx-3">
                  {previllages.add && (
                    <button className="btn  add" onClick={handleNewButtonClick}>
                      Add{" "}
                    </button>
                  )}
                </div>
              </div>
            </div>
            <div className="col-lg-5 col-md-4 col-sm-4 d-flex justify-content-end">

              {/* </div>

            <div className="col-lg-3 col-md-4 col-sm-7"> */}
              <div className="w-full flex-1 me-5">
                <form>
                  <div className="relative">
                    <input
                      className="form-control w-full bg-white appearance-none pl-8 dark:bg-gray-950"
                      placeholder="Search ..."
                      type="search"
                      value={state.globalFilter || ""} // Use the globalFilter value
                      onChange={(e) => setGlobalFilter(e.target.value)} // Update global filter
                    />
                  </div>
                </form>
              </div>
              <div className="d-flex me-2">
                <label className="form-label text-dark mt-1">Show : </label>
                <div>
                  <select
                    className="form-control w-100 mx-2"
                    value={state.pageSize}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === 'All') {
                        setPageSize(data.length);  // 'data' should be your dataset containing all the entries
                      } else {
                        setPageSize(Number(value));
                      }
                    }}
                  >
                    <option value="All">All</option> {/* Add 'All' option */}
                    {[10, 20, 100, 200, 500, 1000].map((pageSize) => (
                      <option key={pageSize} value={pageSize}>
                        {pageSize}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <Table> */}
        <Table {...getTableProps()}>
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <Th
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                  >
                    <div className="d-flex">
                      <div className="mx-2">
                        {column.render("Header")}</div>
                      <div>
                        {column.canFilter ? column.render("Filter") : null}
                      </div>
                      <div className="mx-1">
                        {column.isSorted
                          ? column.isSortedDesc
                            ? " 🔽"
                            : " 🔼"
                          : ""}
                      </div>
                    </div>
                  </Th>
                ))}
                <Th className="text-center">Action</Th>
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.map((row) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => (
                    <Td {...cell.getCellProps()}>{cell.render("Cell")}</Td>
                  ))}
                  <Td className="text-center">
                    <ActionsDropdown
                      row={row.original}
                      permissions={{
                        edit: previllages.edit,
                        delete: previllages.delete,
                      }}
                      onEdit={(id, row) =>
                        handleUpdate(id, row)
                      }
                      onDelete={(id, row) =>
                        handleOpenModal(id, row.course_name)
                      }
                      onInfo={(id, row) =>
                        handleCourseInfo(id, row.course_id)
                      }
                    />
                  </Td>
                </tr>
              );
            })}
          </tbody>
        </Table>
        {/* // */}

        {/* Modal for adding a new user */}

        <Modal
          show={showModal}
          onHide={() => setShowModal(false)}
          className="custom-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title id="modeti">Add Course</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-lg-6">
                <div className="form-group">
                  <div className="floating-label">
                    <label className="form-label">
                      <b></b>
                    </label>
                    <select
                      className="form-select"
                      value={addData.category_list}
                      onChange={(e) =>
                        setAddData({
                          ...addData,
                          category_list: e.target.value,
                        })
                      }
                      required
                    >
                      <option value="">Select Course Category </option>
                      {category.map((item, index) => (
                        <option key={index} value={item.category_name}>
                          {item.category_name}
                        </option>
                      ))}
                    </select>
                    <label
                      className={addData.category_list ? "filled" : ""}
                    ></label>
                  </div>

                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={addData.course_name}
                      onChange={(e) =>
                        setAddData({ ...addData, course_name: e.target.value })
                      }
                      required
                    />
                    <label className={addData.course_name ? "filled" : ""}>
                      Course Name
                    </label>
                  </div>

                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={addData.course_id}
                      onChange={(e) =>
                        setAddData({ ...addData, course_id: e.target.value })
                      }
                      required
                    />
                    <label className={addData.course_id ? "filled" : ""}>
                      Course Code
                    </label>
                  </div>

                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={addData.discount}
                      onChange={(e) =>
                        setAddData({ ...addData, discount: e.target.value })
                      }
                      required
                    />
                    <label className={addData.discount ? "filled" : ""}>
                      Discount Upto
                    </label>
                  </div>

                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={addData.fees}
                      onChange={(e) =>
                        setAddData({ ...addData, fees: e.target.value })
                      }
                      required
                    />
                    <label className={addData.fees ? "filled" : ""}>Fees</label>
                  </div>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="form-group">
                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={addData.description}
                      onChange={(e) =>
                        setAddData({ ...addData, description: e.target.value })
                      }
                      required
                    />
                    <label className={addData.description ? "filled" : ""}>
                      Description
                    </label>
                  </div>

                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={addData.special_offer}
                      onChange={(e) =>
                        setAddData({
                          ...addData,
                          special_offer: e.target.value,
                        })
                      }
                      required
                    />
                    <label className={addData.special_offer ? "filled" : ""}>
                      Special Offer
                    </label>
                  </div>

                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={addData.duration}
                      onChange={(e) =>
                        setAddData({ ...addData, duration: e.target.value })
                      }
                      required
                    />
                    <label className={addData.duration ? "filled" : ""}>
                      Duration
                    </label>
                  </div>

                  <div className="floating-label">
                    <select
                      className="form-control"
                      value={addData.status || ""} // Ensure it defaults to an empty string if undefined
                      onChange={(e) =>
                        setAddData({ ...addData, status: e.target.value })
                      }
                    >
                      <option value="">Select Status</option>
                      <option value="Active">Active</option>
                      <option value="InActive">InActive</option>
                    </select>

                    <label className={addData.status ? "filled" : ""}>
                      Select Status
                    </label>
                  </div>

                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="file"
                      placeholder=""
                      value={addData.image}
                      onChange={(e) =>
                        setAddData({ ...addData, image: e.target.value })
                      }
                      required
                    />
                    <label className={addData.image ? "filled" : ""}>
                      Image Upload
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button
              className="cancelbut"
              variant="secondary"
              onClick={() => setShowModal(false)}
            >
              Cancel
            </Button>
            <Button
              className="submitbut"
              variant="primary"
              onClick={handlesubmit}
            >
              Submit
            </Button>
          </Modal.Footer>
        </Modal>

        {/* ----------------update */}

        <Modal
          show={isUpdateshowModal}
          onHide={() => setUpdateShowModal(false)}
          className="custom-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title id="modeti">Update Course</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-lg-6">
                <div className="form-group">
                  <div className="floating-label">
                    <label className="form-label">
                      <b></b>
                    </label>
                    <select
                      className="form-select"
                      value={updateData.category_list}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          category_name: e.target.value,
                        })
                      }
                    >
                      <option value="">Select Course Category </option>
                      {category.map((item, index) => (
                        <option key={index} value={item.category_name}>
                          {item.category_name}
                        </option>
                      ))}
                    </select>
                    <label
                      className={updateData.category_list ? "filled" : ""}
                    ></label>
                  </div>

                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={updateData.course_name}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          course_name: e.target.value,
                        })
                      }
                      required
                    />
                    <label className={updateData.course_name ? "filled" : ""}>
                      Course Name
                    </label>
                  </div>

                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={updateData.course_id}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          course_id: e.target.value,
                        })
                      }
                      required
                    />
                    <label className={updateData.course_id ? "filled" : ""}>
                      Course Code
                    </label>
                  </div>

                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={updateData.discount}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          discount: e.target.value,
                        })
                      }
                      required
                    />
                    <label className={updateData.discount ? "filled" : ""}>
                      Discount Upto
                    </label>
                  </div>

                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={updateData.description}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          description: e.target.value,
                        })
                      }
                      required
                    />
                    <label className={updateData.description ? "filled" : ""}>
                      Description
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={updateData.special_offer}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          special_offer: e.target.value,
                        })
                      }
                      required
                    />
                    <label className={updateData.special_offer ? "filled" : ""}>
                      Special Offer
                    </label>
                  </div>

                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={updateData.duration}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          duration: e.target.value,
                        })
                      }
                      required
                    />
                    <label className={updateData.duration ? "filled" : ""}>
                      Duration
                    </label>
                  </div>

                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={updateData.fees}
                      onChange={(e) =>
                        setUpdateData({ ...updateData, fees: e.target.value })
                      }
                      required
                    />
                    <label className={updateData.fees ? "filled" : ""}>
                      Fees
                    </label>
                  </div>

                  <div className="floating-label">
                    <select
                      className="form-control"
                      value={updateData.status}
                      placeholder=""
                      onChange={(e) =>
                        setUpdateData({ ...updateData, status: e.target.value })
                      }
                    >
                      <option value="">Select Status</option>
                      <option value="Active">Active</option>
                      <option value="InActive">InActive</option>
                    </select>
                    <label className={updateData.status ? "filled" : ""}>
                      Select Status
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button
              className="cancelbut"
              variant="secondary"
              onClick={() => setUpdateShowModal(false)}
            >
              Cancel
            </Button>
            <Button
              className="submitbut"
              variant="primary"
              onClick={handleupdatesubmit}
            >
              Update
            </Button>
          </Modal.Footer>
        </Modal>

        {/* ----------------delete */}

        <Modal className="modal" show={showModals} onHide={handleCloseModal}>
          <Modal.Header>
            <p id="modeti">Are you sure you want to Delete?</p>
          </Modal.Header>
          <Modal.Body>
            <label className="form-label d-flex">
              <h5 className="mx-1"> Course Name :</h5> <h5>{getdeletename} </h5>
            </label>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="cancelbut"
              variant="secondary"
              onClick={handleCloseModal}
            >
              Close
            </Button>
            <Button
              className="submitbut"
              variant="primary"
              onClick={handleDelete}
            >
              Delete
            </Button>
          </Modal.Footer>
        </Modal>

        {/* _------------------------------pagination button -------------------------------- */}


        <div className="mt-3 pb-5">
          <div className="row">
            <div className="col-lg-7 col-sm-12 mt-1">
              <span className="text-dark">
                Page {state.pageIndex + 1} of {pageCount}
              </span>
            </div>
            <div className="col-lg-5">
              <div className="mt-3 pb-5">
                <nav>
                  <ul className="pagination justify-content-center">
                    {createPagination()} {/* Pagination buttons */}
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>

        {/* ---------------------------------------end ---------------------------------- */}
      </div>
    </>
  );
}

export default Course;
